import {load} from '@shopify/theme-sections';
import '../sections/collection-navbar';
import '../sections/collection';
import Flickity from 'flickity-fade';

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  const slider = document.querySelector('.collection-banner__slider');

  if (slider) {
    // eslint-disable-next-line no-unused-vars
    const flkty = new Flickity(slider, {
      prevNextButtons: false,
      pageDots: false,
      autoPlay: 5000,
      fade: true,
    });
  }
});
